import {
    STRIPE_CONFIG,
    StripeConfig,
} from '@sxm-core/utility-code/angular/configuration-token-stripe-config';

export function providerStripeConfig(config: StripeConfig) {
    return [
        {
            provide: STRIPE_CONFIG,
            useValue: config,
        },
    ];
}
